import { FC, ReactElement } from 'react';

import { IncentivesCard } from '../../../containers';
import { useTypedSelector } from '../../../redux/store';

interface ConnectedIncentivesCardProps {
    onRefresh: () => void;
    className?: string;
}

const ConnectedIncentivesCard: FC<ConnectedIncentivesCardProps> = ({
    onRefresh,
    className = '',
}): ReactElement => {
    const user = useTypedSelector(state => state.userReducer.user);
    const candidate = useTypedSelector(state => state.candidateReducer.candidate);

    const skillsPassportIsLoading = useTypedSelector(state => state.skillsPassportReducer.isLoading);
    const incentives = useTypedSelector(state => state.skillsPassportReducer.incentives);
    const isUpToDate = useTypedSelector(state => state.skillsPassportReducer.isUpToDate);

    return (
        <IncentivesCard
            isLoading={skillsPassportIsLoading}
            isUpToDate={isUpToDate}
            candidateUuid={candidate?.uuid}
            userRoles={user?.roles}
            incentives={incentives}
            handleRefresh={onRefresh}
            className={className}
        />
    );
};

export default ConnectedIncentivesCard;
